import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border text-xs font-medium transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/90 px-2.5 py-0.5",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 px-2.5 py-0.5",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 px-2.5 py-0.5",
        outline: "text-foreground border-border px-2.5 py-0.5",
        indicator: "border-transparent px-3 py-1.5 rounded-full font-medium",
        success: "border-transparent bg-success/10 text-success px-3 py-1.5 rounded-full",
        warning: "border-transparent bg-warning/15 text-[hsl(var(--foreground))] px-3 py-1.5 rounded-full",
        info: "border-transparent bg-info/10 text-info px-3 py-1.5 rounded-full",
        accent: "border-transparent bg-accent/15 text-foreground px-3 py-1.5 rounded-full",
        soft: "border border-border bg-secondary/60 text-foreground px-2.5 py-0.5",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
  }
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
